import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppStoreBadge from "./AppStoreBadge";
import { art } from "./config";

export function Brand() {
  return (
    <Link to="/" className="brand" aria-label="Meet Leo home" data-testid="brand-mark">
      <img src={art("leo-mark-160.png")} alt="" width="30" height="42" />
      Meet Leo
    </Link>
  );
}

export default function Nav({ links = true }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled ? "is-scrolled" : ""}`}>
      <div className="wrap nav-inner">
        <Brand />
        {links && (
          <nav className="nav-links" aria-label="Sections">
            <a href="/#listen">Listen</a>
            <a href="/#how">How it works</a>
            <a href="/#parents">For parents</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#faq">FAQ</a>
          </nav>
        )}
        <AppStoreBadge small testId="nav-app-store" />
      </div>
    </header>
  );
}
